import { Link } from "react-router-dom";
import { LogIn } from "lucide-react";
import { Button } from "@/components/ui/button";
import { BrandLogo } from "@/components/BrandLogo";
import { Footer } from "@/components/Footer";

export default function Login() {
  return (
    <div className="min-h-screen flex flex-col bg-background">
      <div className="h-1 bg-primary" />
      <main className="flex-1 flex items-center justify-center px-4 py-16">
        <div className="w-full max-w-md">
          <div className="surface p-8 md:p-10 shadow-lg" data-testid="login-card">
            <div className="flex justify-center mb-8">
              <BrandLogo variant="full" className="h-20 md:h-24 lg:h-28 w-auto" />
            </div>
            <div className="text-center">
              <h1 className="text-2xl md:text-3xl font-semibold tracking-tight">Voorraad & Inkoop</h1>
              <p className="mt-3 text-base text-muted-foreground">
                Log in om de actuele voorraad- en inkoopstatus te bekijken.
              </p>
            </div>
            <Link to="/">
              <Button data-testid="login-submit" className="w-full mt-8 touch-tap text-base">
                <LogIn className="w-5 h-5 mr-2" /> Inloggen
              </Button>
            </Link>
            <div className="mt-6 text-center text-xs text-muted-foreground">
              Fase 1 — geen wachtwoord vereist. Rollen wisselbaar in de app.
            </div>
          </div>
          <div className="mt-6 text-center text-sm text-muted-foreground">
            Ondersteund door Exact Online (Fase 2).
          </div>
        </div>
      </main>
      <Footer />
    </div>
  );
}
